<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="CS963 prentari">
     CS963 prentari
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_is" title="&Ouml;ryggisuppl&yacute;singar">
     &Ouml;ryggisuppl&yacute;singar
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="Tilkynningar">
      Tilkynningar
     </a>
    </p>
    <p class="toc-2-style">
     <a href="safety-power-cord-topic.html#d0e43" title="Yfirl&yacute;singar um v&ouml;runa">
      Yfirl&yacute;singar um v&ouml;runa
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learn-about-printer-chapter.html#learn-about-printer-chapter_is" title="Fr&aelig;&eth;ast um prentarann">
     Fr&aelig;&eth;ast um prentarann
    </a>
   </p>
   <div id="divd0e213">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_is" title="Finna uppl&yacute;singar um prentarann">
      Finna uppl&yacute;singar um prentarann
     </a>
    </p>
    <p class="toc-2-style">
     <a href="finding-printer-serial-number-topic.html#finding-printer-serial-number_is" title="Finna ra&eth;n&uacute;meri&eth; &aacute; prentaranum">
      Finna ra&eth;n&uacute;meri&eth; &aacute; prentaranum
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-configurations-topic.html#printer-configurations_is" title="Stillingar prentara">
      Stillingar prentara
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_is" title="Nota stj&oacute;rnbor&eth; prentara">
      Nota stj&oacute;rnbor&eth; prentara
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-home-screen-topic.html#using-home-screen_is" title="T&aacute;kn &aacute; heimaskj&aacute;">
      T&aacute;kn &aacute; heimaskj&aacute;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="colors-of-indicator-light-topic.html#colors-of-indicator-light_is" title="Litir gaumlj&oacute;ssins">
      Litir gaumlj&oacute;ssins
     </a>
    </p>
    <p class="toc-2-style">
     <a href="locating-security-slot-topic.html#locating-security-slot_is" title="Finna &ouml;ryggistengi">
      Finna &ouml;ryggistengi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-guidelines-topic.html#d0e715" title="Val &aacute; papp&iacute;r">
      Val &aacute; papp&iacute;r
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-applications-topic.html#d0e10486" title="Vi&eth;b&oacute;tareiginleikar og prentarastu&eth;ningur">
      Vi&eth;b&oacute;tareiginleikar og prentarastu&eth;ningur
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setup-install-and-configure-chapter.html#setup-install-and-configure-chapter_is" title="Setja upp, setja inn og stilla">
     Setja upp, setja inn og stilla
    </a>
   </p>
   <div id="divd0e10604">
    <p class="toc-2-style">
     <a href="selecting-location-printer-topic.html#selecting-location-printer_is" title="Velja sta&eth;setningu fyrir prentarann">
      Velja sta&eth;setningu fyrir prentarann
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-ports-topic.html#printer-ports_is" title="Prentaratengi">
      Prentaratengi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-display-customization-topic.html#d0e10784" title="Stillinga forrita og lausna">
      Stillinga forrita og lausna
     </a>
    </p>
    <p class="toc-2-style">
     <a href="activating-voice-guidance-topic.html#d0e10942" title="Setja upp og nota eiginleika a&eth;gengis">
      Setja upp og nota eiginleika a&eth;gengis
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-trays-group.html#loading-trays-group_is" title="Setja &iacute; papp&iacute;r og s&eacute;rstaka mi&eth;la">
      Setja &iacute; papp&iacute;r og s&eacute;rstaka mi&eth;la
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e11648" title="Setja upp og uppf&aelig;ra hugb&uacute;na&eth;, prentrekla og fastb&uacute;na&eth;">
      Setja upp og uppf&aelig;ra hugb&uacute;na&eth;, prentrekla og fastb&uacute;na&eth;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-optional-550-sheet-tray-topic.html#d0e11951" title="Setja upp valkosti v&eacute;lb&uacute;na&eth;ar">
      Setja upp valkosti v&eacute;lb&uacute;na&eth;ar
     </a>
    </p>
    <p class="toc-2-style">
     <a href="connecting-printer-to-wireless-network-topic.html#d0e13431" title="Nettenging">
      Nettenging
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="secure-printer-chapter.html#secure-printer-chapter_is" title="Gera prentarann &ouml;ruggan">
     Gera prentarann &ouml;ruggan
    </a>
   </p>
   <div id="divd0e13782">
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_is" title="Ey&eth;a minni prentara">
      Ey&eth;a minni prentara
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-storage-drive-topic.html#erasing-printer-storage-drive_is" title="Ey&eth;a af geymsludrifi prentara">
      Ey&eth;a af geymsludrifi prentara
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_is" title="Endurheimta sj&aacute;lfgefnar verksmi&eth;justillingar">
      Endurheimta sj&aacute;lfgefnar verksmi&eth;justillingar
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-topic.html#statement-of-volatility_is" title="Yfirl&yacute;sing var&eth;andi &oacute;st&ouml;&eth;ugleika">
      Yfirl&yacute;sing var&eth;andi &oacute;st&ouml;&eth;ugleika
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="print-chapter.html#print-chapter_is" title="Prentun">
     Prentun
    </a>
   </p>
   <div id="divd0e13972">
    <p class="toc-2-style">
     <a href="printing-from-computer-topic.html#printing-from-computer_is" title="Prentun fr&aacute; t&ouml;lvu">
      Prentun fr&aacute; t&ouml;lvu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-app-topic.html#d0e14023" title="Prentun fr&aacute; fart&aelig;ki">
      Prentun fr&aacute; fart&aelig;ki
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-flash-drive-topic.html#printing-from-flash-drive_is" title="Prentun af minniskorti">
      Prentun af minniskorti
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_is" title="Setja upp tr&uacute;na&eth;arverk">
      Setja upp tr&uacute;na&eth;arverk
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_is" title="Prentun &aacute; tr&uacute;na&eth;arm&aacute;lum og &ouml;&eth;rum verndu&eth;um verkum">
      Prentun &aacute; tr&uacute;na&eth;arm&aacute;lum og &ouml;&eth;rum verndu&eth;um verkum
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-topic.html#printing-font-sample-list_is" title="Prenta lista yfir s&yacute;nishorn leturger&eth;a">
      Prenta lista yfir s&yacute;nishorn leturger&eth;a
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-directory-list-topic.html#printing-directory-list_is" title="Prenta lista skr&aacute;asafns">
      Prenta lista skr&aacute;asafns
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-in-print-jobs-topic.html#placing-separator-sheets-in-print-jobs_is" title="A&eth; setja a&eth;skilna&eth;ars&iacute;&eth;ur &iacute; prentverk">
      A&eth; setja a&eth;skilna&eth;ars&iacute;&eth;ur &iacute; prentverk
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-topic.html#canceling-print-job_is" title="H&aelig;tta vi&eth; verk &iacute; prentun">
      H&aelig;tta vi&eth; verk &iacute; prentun
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-toner-darkness-topic.html#adjusting-toner-darkness_is" title="Stilla svertustig prentdufts">
      Stilla svertustig prentdufts
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printer-menus-chapter.html#printer-menus-chapter_is" title="Valmyndir prentara">
     Valmyndir prentara
    </a>
   </p>
   <div id="divd0e14518">
    <p class="toc-2-style">
     <a href="menu-map-mfp-topic.html#menus-map-mfp_is" title="Yfirlit valmynda">
      Yfirlit valmynda
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e14826" title="T&aelig;ki">
      T&aelig;ki
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e16736" title="Prentun">
      Prentun
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e18017" title="Papp&iacute;r">
      Papp&iacute;r
     </a>
    </p>
    <p class="toc-2-style">
     <a href="flash-drive-print-topic.html#d0e18294" title="USB-drif">
      USB-drif
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e18558" title="Netkerfi/tengi">
      Netkerfi/tengi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="login-methods-subgroup.html#d0e20680" title="&Ouml;ryggi">
      &Ouml;ryggi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cloud-services-enrollment-topic.html#d0e21744" title="Sk&yacute;ja&thorn;j&oacute;nustur">
      Sk&yacute;ja&thorn;j&oacute;nustur
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e21801" title="Sk&yacute;rslur">
      Sk&yacute;rslur
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-menu-topic.html#troubleshooting-menu_is" title="Bilanaleit">
      <strong>
       Bilanaleit
      </strong>
     </a>
    </p>
    <p class="toc-2-style">
     <a href="forms-merge-topic.html#forms-merge_is" title="Sameining ey&eth;ubla&eth;a">
      <strong>
       Sameining ey&eth;ubla&eth;a
      </strong>
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-topic.html#printing-menu-settings-page_is" title="Prentar Stillingars&iacute;&eth;u valmyndar">
      Prentar
      <strong>
       Stillingars&iacute;&eth;u valmyndar
      </strong>
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="using-printer-finisher-options-chapter.html#using-printer-finisher-options-chapter_is" title="Valkostir fr&aacute;gangseiningar prentara">
     Valkostir fr&aacute;gangseiningar prentara
    </a>
   </p>
   <div id="divd0e22189">
    <p class="toc-2-style">
     <a href="using-staple-finisher-topic.html#using-staple-finisher_is" title="notkun heftarab&uacute;na&eth;ar">
      notkun heftarab&uacute;na&eth;ar
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-staple-hole-punch-finisher-topic.html#using-staple-hole-punch-finisher_is" title="Notkun fr&aacute;gangseiningar me&eth; heftara og gatara">
      Notkun fr&aacute;gangseiningar me&eth; heftara og gatara
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-offset-stacker-topic.html#using-offset-stacker_is" title="Nota hli&eth;ra&eth;an staflara">
      Nota hli&eth;ra&eth;an staflara
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-booklet-finisher-topic.html#using-booklet-finisher_is" title="Notkun fr&aacute;gangseiningar b&aelig;klings">
      Notkun fr&aacute;gangseiningar b&aelig;klings
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-hptfu-topic.html#using-hptfu_is" title="Notkun papp&iacute;rsflutnings me&eth; broti">
      Notkun papp&iacute;rsflutnings me&eth; broti
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_is" title="Vi&eth;hald &aacute; prentaranum">
     Vi&eth;hald &aacute; prentaranum
    </a>
   </p>
   <div id="divd0e22598">
    <p class="toc-2-style">
     <a href="checking-supplies-status-topic.html#checking-supplies-status_is" title="Athugun &aacute; st&ouml;&eth;unni &aacute; hlutum og rekstrarv&ouml;rum">
      Athugun &aacute; st&ouml;&eth;unni &aacute; hlutum og rekstrarv&ouml;rum
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-supply-notifications-topic.html#configuring-supply-notifications_is" title="Stilla tilkynningar var&eth;andi rekstrarv&ouml;ru">
      Stilla tilkynningar var&eth;andi rekstrarv&ouml;ru
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-email-alert-topic.html#setting-up-email-alert_is" title="Uppsetning t&ouml;lvup&oacute;stvi&eth;varana">
      Uppsetning t&ouml;lvup&oacute;stvi&eth;varana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="generating-reports-and-logs-topic.html#generating-reports-and-logs_is" title="B&uacute;a til sk&yacute;rslur og kladda">
      B&uacute;a til sk&yacute;rslur og kladda
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-parts-and-supplies-group.html#ordering-parts-and-supplies-group_is" title="P&ouml;ntun &aacute; hlutum og rekstrarv&ouml;rum">
      P&ouml;ntun &aacute; hlutum og rekstrarv&ouml;rum
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-toner-cartridge-topic.html#d0e23197" title="Skipta um hluti og rekstrarv&ouml;rur">
      Skipta um hluti og rekstrarv&ouml;rur
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#d0e23786" title="Hreinsun &aacute; hlutum prentarans">
      Hreinsun &aacute; hlutum prentarans
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-power-save-mode-settings-topic.html#d0e23900" title="Spara orku og papp&iacute;r">
      Spara orku og papp&iacute;r
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-printer-topic.html#moving-printer_is" title="Prentarinn f&aelig;r&eth;ur &aacute; a&eth;ra sta&eth;setningu">
      Prentarinn f&aelig;r&eth;ur &aacute; a&eth;ra sta&eth;setningu
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshoot-problem-chapter.html#troubleshoot-problem-chapter_is" title="Leysa vandam&aacute;l">
     Leysa vandam&aacute;l
    </a>
   </p>
   <div id="divd0e24035">
    <p class="toc-2-style">
     <a href="print-quality-problems-topic.html#print-quality-problems_is" title="Vandam&aacute;l var&eth;andi prentg&aelig;&eth;i">
      Vandam&aacute;l var&eth;andi prentg&aelig;&eth;i
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-error-codes-topic.html#printer-error-codes_is" title="Villuk&oacute;&eth;ar prentara">
      Villuk&oacute;&eth;ar prentara
     </a>
    </p>
    <p class="toc-2-style">
     <a href="print-quality-is-poor-subgroup.html#d0e25210" title="Vandam&aacute;l vi&eth; prentun">
      Vandam&aacute;l vi&eth; prentun
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-printer-not-responding-topic.html#trb-printer-not-responding_is" title="Prentarinn svarar ekki">
      Prentarinn svarar ekki
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-unable-to-read-flash-drive-topic.html#trb-unable-to-read-flash-drive_is" title="Get ekki lesi&eth; minniskort">
      Get ekki lesi&eth; minniskort
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-usb-port-topic.html#enabling-usb-port_is" title="Virkja USB-tengi&eth;">
      Virkja USB-tengi&eth;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="clearing-jams.html#clearing-jams_is" title="Losa um fl&aelig;kjur">
      Losa um fl&aelig;kjur
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e27191" title="Vandam&aacute;l vi&eth; nettengingu">
      Vandam&aacute;l vi&eth; nettengingu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-detect-internal-option-topic.html#d0e27282" title="Vandam&aacute;l var&eth;andi valkosti v&eacute;lb&uacute;na&eth;ar">
      Vandam&aacute;l var&eth;andi valkosti v&eacute;lb&uacute;na&eth;ar
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e27450" title="Vandam&aacute;l var&eth;andi rekstarv&ouml;rur">
      Vandam&aacute;l var&eth;andi rekstarv&ouml;rur
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-paper-curl-topic.html#d0e27598" title="Vandam&aacute;l vi&eth; m&ouml;tun papp&iacute;rs">
      Vandam&aacute;l vi&eth; m&ouml;tun papp&iacute;rs
     </a>
    </p>
    <p class="toc-2-style">
     <a href="modifying-colors-in-printed-output-topic.html#d0e27792" title="Vandam&aacute;l var&eth;andi prentg&aelig;&eth;i lita">
      Vandam&aacute;l var&eth;andi prentg&aelig;&eth;i lita
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_is" title="Hafa samband vi&eth; stu&eth;ning vi&eth;skiptavina">
      Hafa samband vi&eth; stu&eth;ning vi&eth;skiptavina
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="recycle-dispose-chapter.html#recycle-dispose-chapter_is" title="Endurvinnsla og f&ouml;rgun">
     Endurvinnsla og f&ouml;rgun
    </a>
   </p>
   <div id="divd0e28016">
    <p class="toc-2-style">
     <a href="recycling-lexmark-products-topic.html#recycling-lexmark-products_is" title="Endurn&yacute;ting &aacute; v&ouml;rum Lexmark">
      Endurn&yacute;ting &aacute; v&ouml;rum Lexmark
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling-lexmark-packaging-topic.html#recycling-lexmark-packaging_is" title="Endurvinnsla Lexmark umb&uacute;&eth;a">
      Endurvinnsla Lexmark umb&uacute;&eth;a
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_is" title="Tilkynningar">
     Tilkynningar
    </a>
   </p>
   <div id="divd0e28050">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e28053" title="V&ouml;ruuppl&yacute;singar">
      V&ouml;ruuppl&yacute;singar
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e28070" title="Tilkynning var&eth;andi &uacute;tg&aacute;fu">
      Tilkynning var&eth;andi &uacute;tg&aacute;fu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_is" title="V&ouml;rumerki">
      V&ouml;rumerki
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_is" title="Tilkynningar var&eth;andi leyfism&aacute;l">
      Tilkynningar var&eth;andi leyfism&aacute;l
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_is" title="Stig h&aacute;va&eth;amengunar">
      Stig h&aacute;va&eth;amengunar
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#weee-directive_is" title="Tilskipun vegna &uacute;rgangs fr&aacute; raf- og rafeindab&uacute;na&eth;i (WEEE)">
      Tilskipun vegna &uacute;rgangs fr&aacute; raf- og rafeindab&uacute;na&eth;i (WEEE)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e28168" title="Lit&iacute;um-&iacute;on endurhla&eth;anleg rafhla&eth;a">
      Lit&iacute;um-&iacute;on endurhla&eth;anleg rafhla&eth;a
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#eu-battery-directive-2023-1542_is" title="Regluger&eth; (ESB) 2023/1542">
      Regluger&eth; (ESB) 2023/1542
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e28205" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal_is" title="F&ouml;rgun &aacute; v&ouml;runni">
      F&ouml;rgun &aacute; v&ouml;runni
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_is" title="Skil &aacute; Lexmark-hylkjum til endurnota e&eth;a endurn&yacute;tingar">
      Skil &aacute; Lexmark-hylkjum til endurnota e&eth;a endurn&yacute;tingar
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_is" title="Tilkynning vegna st&ouml;&eth;urafmagns">
      Tilkynning vegna st&ouml;&eth;urafmagns
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star_is" title="ENERGY STAR">
      ENERGY STAR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_is" title="Uppl&yacute;singar um hitastig">
      Uppl&yacute;singar um hitastig
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-notice_is" title="Tilkynning um leysigeisla">
      Tilkynning um leysigeisla
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption_is" title="Orkunotkun">
      Orkunotkun
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e28466" title="Tilkynningar eftirlitsa&eth;ila var&eth;andi &thorn;r&aacute;&eth;lausar v&ouml;rur">
      Tilkynningar eftirlitsa&eth;ila var&eth;andi &thorn;r&aacute;&eth;lausar v&ouml;rur
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#modular-component-notice_is" title="Tilkynning um hlut einingar">
      Tilkynning um hlut einingar
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#exposure-to-radio-frequency-radiation_is" title="V&aacute;hrif af v&ouml;ldum &uacute;tgeislunar &uacute;tvarpst&iacute;&eth;ni">
      V&aacute;hrif af v&ouml;ldum &uacute;tgeislunar &uacute;tvarpst&iacute;&eth;ni
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e28491" title="Samr&aelig;mi vi&eth; tilskipanir Evr&oacute;pusambandsins (EB)">
      Samr&aelig;mi vi&eth; tilskipanir Evr&oacute;pusambandsins (EB)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#european-community-ec-directives-conformity-class-a_is" title="Samr&aelig;mi vi&eth; tilskipanir Evr&oacute;pusambandsins (EB)">
      Samr&aelig;mi vi&eth; tilskipanir Evr&oacute;pusambandsins (EB)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#radio-interference-notice_is" title="Tilkynning um &uacute;tvarpstruflanir">
      Tilkynning um &uacute;tvarpstruflanir
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue